class MFooter extends HTMLElement {
  constructor() {
    super();
    this.mobileMql = window.matchMedia('(max-width: 767px)');
    this.onFooterClick = this.onFooterClick.bind(this);
    this.onFooterKeydown = this.onFooterKeydown.bind(this);
    this.onViewportChange = this.onViewportChange.bind(this);
    this.init();
  }

  init() {
    this.accordion = this.querySelector('.m-footer--accordion');
    this.mobileStickyBar = document.querySelector('.m-mobile-sticky-bar');

    if (this.accordion) {
      this.prepareAccordion();
      this.accordion.addEventListener('click', this.onFooterClick);
      this.accordion.addEventListener('keydown', this.onFooterKeydown);
      if (this.mobileMql.addEventListener) {
        this.mobileMql.addEventListener('change', this.onViewportChange);
      } else {
        this.mobileMql.addListener(this.onViewportChange);
      }
    }

    this.updateStickyBarHeight();
    document.addEventListener('matchMobile', () => {
      this.prepareAccordion();
      this.updateStickyBarHeight();
    });
    document.addEventListener('unmatchMobile', () => {
      this.prepareAccordion();
      this.updateStickyBarHeight();
    });
  }

  prepareAccordion() {
    if (!this.accordion) return;
    const isMobile = this.mobileMql.matches;

    this.accordion.querySelectorAll('.m-footer--block.m-accordion--item').forEach((item) => {
      const trigger = item.querySelector('.m-accordion--item-button');
      if (!trigger) return;

      if (isMobile) {
        const shouldOpen = item.classList.contains('open') || item.classList.contains('vm-footer-open');
        item.classList.toggle('vm-footer-open', shouldOpen);
        trigger.setAttribute('role', 'button');
        trigger.setAttribute('tabindex', '0');
        trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      } else {
        item.classList.remove('vm-footer-open');
        trigger.removeAttribute('role');
        trigger.removeAttribute('tabindex');
        trigger.removeAttribute('aria-expanded');
      }
    });
  }

  toggleItem(trigger) {
    if (!this.mobileMql.matches) return;
    const item = trigger.closest('.m-footer--block.m-accordion--item');
    if (!item) return;

    const willOpen = !item.classList.contains('vm-footer-open');
    item.classList.toggle('vm-footer-open', willOpen);
    item.classList.toggle('open', willOpen);
    trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
  }

  onFooterClick(event) {
    if (!this.mobileMql.matches) return;
    const trigger = event.target.closest('.m-accordion--item-button');
    if (!trigger || !this.accordion.contains(trigger)) return;
    event.preventDefault();
    this.toggleItem(trigger);
  }

  onFooterKeydown(event) {
    if (!this.mobileMql.matches || (event.key !== 'Enter' && event.key !== ' ')) return;
    const trigger = event.target.closest('.m-accordion--item-button');
    if (!trigger || !this.accordion.contains(trigger)) return;
    event.preventDefault();
    this.toggleItem(trigger);
  }

  onViewportChange() {
    this.prepareAccordion();
  }

  updateStickyBarHeight() {
    if (!this.mobileStickyBar) return;
    document.documentElement.style.setProperty('--mobile-sticky-bar-height', `${this.mobileStickyBar.offsetHeight}px`);
  }

  disconnectedCallback() {
    if (this.accordion) {
      this.accordion.removeEventListener('click', this.onFooterClick);
      this.accordion.removeEventListener('keydown', this.onFooterKeydown);
    }
    if (this.mobileMql && this.mobileMql.removeEventListener) {
      this.mobileMql.removeEventListener('change', this.onViewportChange);
    }
  }
}

if (!customElements.get('m-footer')) {
  customElements.define('m-footer', MFooter);
}
